(function() {
    'use strict';

    angular
        .module('jotApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('warning', {
            parent: 'alerting',
            url: '/admin/rules?page&sort&search&systemPage&systemSort',
            data: {
                authorities: ['ROLE_TECH'],
                pageTitle: 'jotApp.alertRules.home.title'
            },
            views: {
                'content@main': {
                    templateUrl: 'app/entities/warning/warnings.html',
                    controller: 'WarningController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    squash: true
                },
                systemPage: {
                    value: '1',
                    squash: true
                },
                systemSort: {
                    squash: true
                },
                fleet: {
                    value: -1,
                    fleetName: true
                },
                objectType:{
                    value: -1,
                    squash: true
                },
                search: null,
                predicates : {},
                systemPredicates : {},
                itemsPerPageChosen: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        systemPage: PaginationUtil.parsePage($stateParams.systemPage),
                        systemSort: $stateParams.systemSort,
                        predicates : $stateParams.predicates,
                        systemPredicates : $stateParams.systemPredicates,
                        fleet: $stateParams.fleet,
                        objectType: $stateParams.objectType,
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('warning');
                    $translatePartialLoader.addPart('alertRules');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }],
                domain: ['TabDomains', function(TabDomains) {
                    return  TabDomains.current();
                }]
            }
        })
        .state('warning-detail', {
            parent: 'warning',
            url: '/admin/rule/{id}',
            data: {
                authorities: ['ROLE_TECH'],
                pageTitle: 'jotApp.alertRules.detail.title'
            },
            views: {
                'content@main': {
                    templateUrl: 'app/entities/warning/warning-detail.html',
                    controller: 'WarningDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('warning');
                    $translatePartialLoader.addPart('alertRules');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Warning', function($stateParams, Warning) {
                    return Warning.get({id : $stateParams.id});
                }]
            }
        })
        .state('warning-new', {
            parent: 'warning',
            url: '/new',
            data: {
                authorities: ['ROLE_TECH'],
                pageTitle: 'jotApp.alertRules.detail.title'
            },
            views: {
                'content@main': {
                    templateUrl: 'app/entities/warning/warning-dialog.html',
                    controller: 'WarningDialogController',
                    controllerAs: 'vm'
                }
            },
            params: {
                type: null
            },
            resolve: {
                pagingParams: ['$stateParams', function ($stateParams) {
                    return {
                        type: $stateParams.type
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('warning');
                    $translatePartialLoader.addPart('alertRules');
                    return $translate.refresh();
                }],
                entity: function () {
                    return {
                        query: null,
                        description: null,
                        active: false,
                        channel: null,
                        message: null,
                        level: null,
                        frequency: null,
                        id: null
                    };
                }
            }
        })
        .state('warning-edit', {
            parent: 'warning',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_TECH'],
                pageTitle: 'jotApp.alertRules.detail.title'
            },
            views: {
                'content@main': {
                    templateUrl: 'app/entities/warning/warning-dialog.html',
                    controller: 'WarningDialogController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('warning');
                    $translatePartialLoader.addPart('alertRules');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Warning', function($stateParams, Warning) {
                    return Warning.get({id : $stateParams.id});
                }]
            }
        })
        .state('warning-clone', {
            parent: 'warning',
            url: '/{id}/clone',
            data: {
                authorities: ['ROLE_TECH'],
                pageTitle: 'jotApp.alertRules.detail.title'
            },
            views: {
                'content@main': {
                    templateUrl: 'app/entities/warning/warning-dialog.html',
                    controller: 'WarningDialogController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('warning');
                    $translatePartialLoader.addPart('alertRules');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Warning', function($stateParams, Warning) {
                    return Warning.getClone({id : $stateParams.id}).$promise.then(function (data) {
                        data.cloned = true;
                        return data;
                    });
                }]
            }
        })
        .state('warning.delete', {
            parent: 'warning',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_TECH']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/warning/warning-delete-dialog.html',
                    controller: 'WarningDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                            $translatePartialLoader.addPart('warning');
                            $translatePartialLoader.addPart('alertRules');
                            return $translate.refresh();
                        }],
                        entity: ['Warning', function(Warning) {
                            return Warning.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('warning', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('warning-edit-query', {
            parent: 'warning',
            url: '/edit-query',
            data: {
                authorities: ['ROLE_TECH'],
                pageTitle: 'jotApp.alertRules.detail.title'
            },
            views: {
                'content@main': {
                    templateUrl: 'app/entities/warning/warning-dialog-query.html',
                    controller: 'WarningDialogQueryController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('warning');
                    $translatePartialLoader.addPart('alertRules');
                    return $translate.refresh();
                }]
            }
        });
    }

})();
